module.exports = __webpack_public_path__ + "static/media/paper.fac26459.png";